import { useQuery } from "@tanstack/react-query";
import { fetchProtocolPNL, type ProtocolPNL } from "@/services";
import { QUERY_KEYS, QUERY_CONFIG } from "@/config";
import { useAccount } from "wagmi";
import { useMemo } from "react";

export function useProtocolPNL(address?: string) {
    const { address: accountAddress } = useAccount();
    const resolvedAddress = address ?? accountAddress;

    const { data, isLoading, error } = useQuery<ProtocolPNL>({
        queryKey: QUERY_KEYS.PROTOCOL.PNL(resolvedAddress!),
        queryFn: () => fetchProtocolPNL(resolvedAddress!),
        enabled: !!resolvedAddress,
        ...QUERY_CONFIG.PROTOCOL,
    });

    // const unwindingProfit = data?.unwindingProfitNormalized ?? 0;

    const totalRewards = useMemo(() => {
        if (!data) return 0;
        const { stakedProfitNormalized, lockedProfitNormalized, unwindingProfitNormalized } = data;

        const total =
            stakedProfitNormalized +
            unwindingProfitNormalized +
            Object.values(lockedProfitNormalized).reduce((acc, val) => acc + val, 0);

        return total;
    }, [data]);

    return { data, isLoading, error, totalRewards };
}
